/** Правила сутностей прототипу (designEntities: MOD_ENTITIES і MOD_ENTITIES_EXTRA) для лівого меню модуля. Чисті функції. */
import { localized } from '@platform/core/lib/localized';
import type { IDesignEntity, IRecordTypeDefinition, Lang } from '@platform/core/types';
import { moduleBundle } from '@platform/i18n';

/** Класифікатор прототипу (isCat): англійська назва закінчується на Status, Type, Topic, Category, Template, Location, Venue, Channel, Segment, Campaign. */
const CATALOGUE = / (Status|Type|Topic|Category|Template|Location|Venue|Channel|Segment|Campaign)$/;

const en = (text: { en?: string | null } | null | undefined): string => (text?.en ?? '').trim();

export function isCatalogueEntity(entity: IDesignEntity): boolean {
  return CATALOGUE.test(en(entity.name));
}

/**
 * Сутність — окрема таблиця в «Таблицях» (прототип child): не класифікатор, не сам головний тип (`main`: назва й однина), не повтор
 * реалізованої дочірньої таблиці `kids` (назва сутності — однина чи назва таблиці або закінчується її одниною: «Draft Article» — «Article») і
 * не позначена імпортером як прихована в меню (`menu: false` — правило прототипу isMod для модулів NEW_SEEDS).
 */
export function isTableEntity(entity: IDesignEntity, main: IRecordTypeDefinition, kids: readonly IRecordTypeDefinition[]): boolean {
  const name = en(entity.name);
  if (!name || isCatalogueEntity(entity) || name === en(main.singular) || name === en(main.name)) return false;
  if (entity.menu === false) return false;
  return !kids.some((k) => name === en(k.singular) || name === en(k.name) || (en(k.singular) !== '' && name.endsWith(` ${en(k.singular)}`)));
}

/** Підпис сутності мовою `lang`: рядок пакета модуля `entities.<тип>.designEntities.<i>.label`, інакше підпис визначення. */
export function designEntityLabel(lang: Lang, moduleKey: string, rtKey: string, index: number, entity: IDesignEntity): string {
  const own = (moduleBundle(lang, moduleKey)?.entities?.[rtKey] as { designEntities?: Record<string, { label?: unknown }> } | undefined)?.designEntities?.[String(index)]?.label;
  return (typeof own === 'string' && own.trim()) || localized(entity.label, lang) || en(entity.name);
}
